import React from "react";
import axios from "axios";
import { json } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import parse from "html-react-parser";

// Components
import styles from "../components/roadmap/roadmap.module.scss";

export async function loader({ context }) {
  try {
    const response = await axios
      .get(`${context.cloudflare.env.STRAPI_BASE_URL}/api/roadmap?populate[0]=items.image`, {
        headers: {
          Authorization: `Bearer ${context.cloudflare.env.STRAPI_API_TOKEN}`,
        },
      })
      .then((res) => res.data);

    return json({
      items: response?.data?.attributes?.items,
    });
  } catch (error) {
    console.error("ERROR", error);

    return json({
      items: [],
    });
  }
}

export default function Roadmap() {
  const { items } = useLoaderData();

  return (
    <>
      <h1 className="text-center mb-sm-0 mb-lg-10">Roadmap</h1>
      <div className={`container mb-10 ${styles.timeline}`}>
        {items?.map((item, index) => {
          return (
            <div key={index} className={styles["timeline-row"]}>
              <div className={styles["timeline-time"]}>
                <h4>{item.date}</h4>
              </div>
              <div className={`${styles["timeline-content"]} position-relative bg-secondary`}
              >
                <i className="bi bi-paperclip"></i>

                <h4 className="w-100 d-flex align-items-center gap-2">
                  {item.title}
                  {item.released && (
                    <span className="badge bg-success text-white" style={{ fontSize: "0.75rem" }}>
                      Released
                    </span>
                  )}
                </h4>

                {/* {parse(item.description || "")} */}

                <div dangerouslySetInnerHTML={{ __html: item.description || "" }} />


                <img
                  className={`${styles["timeline-image"]}`}
                  style={{ width: 60 }}
                  src={item.image?.data?.attributes?.url}
                  alt={item.title}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
